import { render, staticRenderFns } from "./ArtigosSuggestionCard.vue?vue&type=template&id=6ff5d3a6&scoped=true&"
import script from "./ArtigosSuggestionCard.vue?vue&type=script&lang=js&"
export * from "./ArtigosSuggestionCard.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosSuggestionCard.vue?vue&type=style&index=0&id=6ff5d3a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff5d3a6",
  null
  
)

export default component.exports